import React from "react";
import {
  Card,
  CardStackSection,
  Stack,
  Text,
  Heading,
  TextLink,
} from "@origin-digital/ods-core";
import { IconCheckCircle } from "@origin-digital/ods-icons";
import { getConnectionTypeLabels } from "./helper";
import { EICFormData } from "./types";
import styled from "styled-components";

interface EICSuccessPageProps {
  formData: EICFormData;
}

// Styled component for the icon
const StyledCheckIcon = styled(IconCheckCircle)`
  font-size: 48px !important;
`;

const EICSuccessPage: React.FC<EICSuccessPageProps> = ({ formData }) => {
  const services = getConnectionTypeLabels(formData.connectionTypes, true);

  return (
    <CardStackSection>
      <Card>
        {/* Body */}
        <Stack space={["xlarge", "xxlarge"]}>
          {/* Content */}
          <Stack alignX="center">
            <StyledCheckIcon size="medium" color="positiveLight" />
            <Heading variant="h3" align="center">
              Success!
            </Heading>
            <Text align="center">
              We'll progress with the connection of {services.toLowerCase()}{" "}
              supply at {formData.address}.
            </Text>
          </Stack>
          {/* End Content */}
          <Stack space="medium">
            <Heading variant="h4">What happens next?</Heading>
            <Text>
              We'll now join your information with the connection details at
              these premises to progress the request. Rest assured, we will keep
              you informed throughout the process.
            </Text>
            <Text>
              If you have any questions or would like an update on the status of
              your connection, you can contact us at{" "}
              <TextLink href="mailto:ncorigin@originenergy.com.au">
                ncorigin@originenergy.com.au
              </TextLink>
              . We're here to help!
            </Text>
          </Stack>
        </Stack>
        {/* End Body */}
      </Card>
    </CardStackSection>
  );
};

export default EICSuccessPage;
